import DestinationIconList from './DestinationIconList';

export default DestinationIconList;
